export function Section({ badge, title, sub }: { badge: string; title: string; sub?: string }) {
	return (
		<>
			<div className="shead">
				<span className="sbadge" aria-hidden="true">
					{badge}
				</span>
				<h2 className="stitle">{title}</h2>
			</div>
			{sub && <p className="sub">{sub}</p>}
		</>
	);
}
